'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import PlanoPaginaMobileFallback from '../Designs/Mobile/fallback';
import PlanoPaginaDesktopFallback from '../Designs/Desktop/fallback';

export default function PlanoPaginaFallback() {
  const { breakpoint } = useBreakpoint();
  return breakpoint === 'mobile' ? (
    <PlanoPaginaMobileFallback />
  ) : (
    <PlanoPaginaDesktopFallback />
  );
}
